import isPropValid from '@emotion/is-prop-valid';
import styled from '@emotion/styled';
import { GridColumn } from 'semantic-ui-react';

export const MinWidthColumn = styled(GridColumn, {
  shouldForwardProp: isPropValid,
})`
  &.column {
    width: auto !important;
    min-width: ${(props) => props.minWidth || 'auto'};
  }
`;
